import { NODE_TYPES } from 'modules/workflows/constants';
import { Node, NodeResource } from 'modules/workflows/types';

/** Should the node card be shown? */
export const shouldShowNodeCard = (focusedNodes: Node[] = []) => {
  // Do not show if more than one node is selected
  if (focusedNodes.length !== 1) return false;
  const [node] = focusedNodes;
  // Do not show if node is a note
  return node?.type !== NODE_TYPES.NOTE;
};

export const getNodesCampaignsIds = (nodes: Node[] = []) => {
  return nodes
    .map((n: Node) => {
      const { resource } = n;

      if (!!resource && 'resources' in resource) {
        return (resource?.resources || []).map((channel: NodeResource) => channel.campaign) || [];
      }
      return resource?.campaign;
    }, [])
    .flat()
    .map((n) => n.id) as number[];
};
